import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionZipCodeSlideOut extends Layout {
    panelTariffZipCode: Panel;
    sourceTariffRegionZip: DataSource;
    textboxEffectiveTimestamp: Textbox;
    textboxExpireTimestamp: Textbox;
    textboxFdZipcode: Textbox;
    textboxStateId: Textbox;
}
